/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length)
/******/ 			resolves.shift()();
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return Promise.resolve();
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunks[chunkId]) {
/******/ 			return installedChunks[chunkId][2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunks[chunkId][2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(4)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(2),
  /* template */
  __webpack_require__(6),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'range-slider',
	props: {
		name: {
			type: String,
			default: 'range-slider'
		},
		min: {
			type: Number,
			default: 0
		},
		max: {
			type: Number,
			default: 100
		},
		step: {
			type: Number,
			default: 1
		},
		formatter: {
			type: String,
			default: '{value}'
		},
		orientation: {
			type: String,
			default: 'horizontal'
		},
		value: {
			type: Array,
			default: function _default() {
				return [0, 100];
			}
		},
		lazy: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			HAS_INTERACTION: false,
			IS_LOOPING: false,
			EASE: 0.25,
			POINTER_X: 0,
			POINTER_Y: 0,
			X_MIN: 0,
			X_MAX: 100,
			Y_MIN: 0,
			Y_MAX: 100,
			CONTROL_MIN: {
				X: 0,
				Y: 0
			},
			CONTROL_MAX: {
				X: 0,
				Y: 0
			},
			SLIDER_WIDTH: 0,
			SLIDER_HEIGHT: 0,
			IS_DESTROYED: true,
			$currentTarget: null
		};
	},

	computed: {

		/**
   * Get the number of decimals to display
   * from the given `step` value
   */
		DECIMALS: function DECIMALS() {
			var decimals = ('' + this.step).split('.')[1];
			return decimals ? decimals.length : 0;
		},


		/**
   * Get the range between the minimum
   * and the maximum values
   */
		DIFF: function DIFF() {
			return this.max - this.min;
		},


		/**
   * Get the minimum value from
   * the current minium X position
   */
		VALUE_MIN: function VALUE_MIN() {
			var VALUE = void 0;

			if (this.orientation === 'horizontal') {
				VALUE = Math.round((this.CONTROL_MIN.X * this.DIFF / this.SLIDER_WIDTH + this.min) / this.step) * this.step;
			} else {
				VALUE = Math.round((this.CONTROL_MIN.Y * this.DIFF / this.SLIDER_HEIGHT + this.min) / this.step) * this.step;
			}

			return VALUE.toFixed(this.DECIMALS);
		},


		/**
   * Get the maximum value from
   * the current maximum X position
   */
		VALUE_MAX: function VALUE_MAX() {
			var VALUE = void 0;

			if (this.orientation === 'horizontal') {
				VALUE = Math.round((this.CONTROL_MAX.X * this.DIFF / this.SLIDER_WIDTH + this.min) / this.step) * this.step;
			} else {
				VALUE = Math.round((this.CONTROL_MAX.Y * this.DIFF / this.SLIDER_HEIGHT + this.min) / this.step) * this.step;
			}

			return VALUE.toFixed(this.DECIMALS);
		}
	},
	methods: {

		/**
   * Start updating values and position
   *
   * @param  {Object} $target   The current targetted $control
   * @param  {Number} POINTER_X The current pointer X position
   * @param  {Number} POINTER_Y The current pointer Y position
   */
		start: function start($target, POINTER_X, POINTER_Y) {
			// Make sure our target is the
			// control and not the tooltip
			if (!$target.__TYPE) {
				$target = $target.parentElement;
			}

			this.HAS_INTERACTION = true;

			this.updatePointerPosition(POINTER_X, POINTER_Y);
			this.X = this.getX($target.__TYPE);
			this.Y = this.getY($target.__TYPE);
			this.$currentTarget = $target;
			this.IS_LOOPING = true;
		},


		/**
   * End updating values and position,
   * emit the current values
   */
		end: function end() {
			this.$currentTarget = null;
			this.IS_LOOPING = false;
			this.HAS_INTERACTION = false;
			this.emitValue();
		},


		/**
   * Update the pointer's position vars
   *
   * @param  {Number} X The pointer's current X position
   * @param  {Number} Y The pointer's current Y position
   */
		updatePointerPosition: function updatePointerPosition(X, Y) {
			this.POINTER_X = X;
			this.POINTER_Y = Y;
		},


		/**
   * Update the range slider sizes' vars
   */
		updateSizes: function updateSizes() {
			var SIZES = this.$slider.getBoundingClientRect();

			this.SLIDER_WIDTH = SIZES.width;
			this.SLIDER_HEIGHT = SIZES.height;

			this.X_MIN = SIZES.left;
			this.X_MAX = SIZES.left + SIZES.width;

			this.Y_MIN = SIZES.top;
			this.Y_MAX = SIZES.top + SIZES.height;
		},


		/**
   * Update the current value and the
   * controls positions
   *
   * @param  {Array} VALUE The new value
   */
		updateValue: function updateValue(VALUE) {
			this.CONTROL_MIN.X = (VALUE[0] - this.min) * this.SLIDER_WIDTH / this.DIFF;
			this.CONTROL_MIN.Y = (VALUE[0] - this.min) * this.SLIDER_HEIGHT / this.DIFF;

			this.CONTROL_MAX.X = (VALUE[1] - this.min) * this.SLIDER_WIDTH / this.DIFF;
			this.CONTROL_MAX.Y = (VALUE[1] - this.min) * this.SLIDER_HEIGHT / this.DIFF;

			this.updatePosition();
		},


		/**
   * Emit the current value to the parent
   *
   */
		emitValue: function emitValue() {
			var min = Number(this.VALUE_MIN).toFixed(this.DECIMALS);
			var max = Number(this.VALUE_MAX).toFixed(this.DECIMALS);
			this.$emit('input', [Number(min), Number(max)]);
		},


		/**
   * Format the given value with
   * the formatter string
   *
   * @param  {String} value The value to format
   * @return {String}       The formatted value
   */
		formatValue: function formatValue(value) {
			return this.formatter.replace('{value}', value);
		},


		/**
   * Get the current control X position
   * in function of the slider's size and
   * the other control's X position
   *
   * @param  {String} TYPE The type of the current control
   * @return {Number}      The current X position
   */
		getX: function getX(TYPE) {
			var X = this.POINTER_X < this.X_MIN ? 0 : this.POINTER_X > this.X_MAX ? this.SLIDER_WIDTH : this.POINTER_X - this.X_MIN;

			if (TYPE === 'CONTROL_MIN') {
				return X > this.CONTROL_MAX.X ? this.CONTROL_MAX.X : X;
			} else {
				return X < this.CONTROL_MIN.X ? this.CONTROL_MIN.X : X;
			}
		},


		/**
   * Get the current control Y position
   * in function of the slider's size and
   * the other control's Y position
   *
   * @param  {String} TYPE The type of the current control
   * @return {Number}      The current Y position
   */
		getY: function getY(TYPE) {
			var Y = this.POINTER_Y < this.Y_MIN ? 0 : this.POINTER_Y > this.Y_MAX ? this.SLIDER_HEIGHT : this.POINTER_Y - this.Y_MIN;

			if (TYPE === 'CONTROL_MIN') {
				return Y > this.CONTROL_MAX.Y ? this.CONTROL_MAX.Y : Y;
			} else {
				return Y < this.CONTROL_MIN.Y ? this.CONTROL_MIN.Y : Y;
			}
		},


		/**
   * The loop responsible for all the good stuff
   */
		loop: function loop() {
			if (this.IS_DESTROYED || !this.IS_LOOPING) return false;

			if (this.$currentTarget !== null) {
				var TYPE = this.$currentTarget.__TYPE;

				// Horizontal layout
				if (this.orientation === 'horizontal') {
					var X = this.getX(TYPE);
					this[TYPE].X += (X - this[TYPE].X) * this.EASE;
				}

				// Vertical layout
				if (this.orientation === 'vertical') {
					var Y = this.getY(TYPE);
					this[TYPE].Y += (Y - this[TYPE].Y) * this.EASE;
				}

				this.updatePosition();
				if (!this.lazy) this.emitValue();
			}
			requestAnimationFrame(this.loop.bind(this));
		},


		/**
   * Update the elements' positions
   */
		updatePosition: function updatePosition() {
			if (this.orientation === 'horizontal') {
				this.$controls[0].style.transform = 'translate3d(' + this.CONTROL_MIN.X + 'px, 0, 0)';
				this.$controls[1].style.transform = 'translate3d(' + this.CONTROL_MAX.X + 'px, 0, 0)';
				this.$filled.style.left = this.CONTROL_MIN.X + 'px';
				this.$filled.style.right = this.SLIDER_WIDTH - this.CONTROL_MAX.X + 'px';
			} else {
				this.$controls[0].style.transform = 'translate3d(0, ' + this.CONTROL_MIN.Y + 'px, 0)';
				this.$controls[1].style.transform = 'translate3d(0, ' + this.CONTROL_MAX.Y + 'px, 0)';
				this.$filled.style.top = this.CONTROL_MIN.Y + 'px';
				this.$filled.style.bottom = this.SLIDER_HEIGHT - this.CONTROL_MAX.Y + 'px';
			}
		},


		/**
   * Helper to loop over a nodeList
   *
   * @param  {Array|NodeList}  array
   * @param  {Function}        callback
   * @param  {Object}          scope
   */
		forEach: function forEach(array, callback, scope) {
			var length = array.length;
			for (var i = 0; i < length; i++) {
				callback.call(scope, array[i], i);
			}
		},


		/**
   * Dispatch events to their handler
   *
   * @param  {Object} e The event's object
   */
		handleEvent: function handleEvent(e) {
			try {
				this[e.type + 'Handler'](e);
			} catch (e) {}
		},


		/**
   * Window resize event's handler
   *
   * @param  {Object} e The event's object
   */
		resizeHandler: function resizeHandler(e) {
			this.updateSizes();
		},


		/**
   * The controls mousedown events' handler
   *
   * @param  {Object} event.target  The target of the event
   * @param  {Number} event.clientX The current X pointer position
   * @param  {Number} event.clientY The current Y pointer position
   */
		mousedownHandler: function mousedownHandler(_ref) {
			var target = _ref.target,
			    clientX = _ref.clientX,
			    clientY = _ref.clientY;

			document.addEventListener('mousemove', this);
			document.addEventListener('mouseup', this);
			this.start(target, clientX, clientY);
		},


		/**
   * Document mouseup event's handler
   *
   * @param  {Object} e The event's object
   */
		mouseupHandler: function mouseupHandler(e) {
			document.removeEventListener('mousemove', this);
			document.removeEventListener('mouseup', this);
			this.end();
		},


		/**
   * Document mousemove event's handler
   *
   * @param  {Number} event.clientX The current X pointer position
   * @param  {Number} event.clientY The current Y pointer position
   */
		mousemoveHandler: function mousemoveHandler(_ref2) {
			var clientX = _ref2.clientX,
			    clientY = _ref2.clientY;

			this.updatePointerPosition(clientX, clientY);
		},


		/**
   * The control's touchstart event's handler
   *
   * @param  {Object} event.target  The target of the event
   * @param  {Array}  event.touches The list of all the touch
   */
		touchstartHandler: function touchstartHandler(_ref3) {
			var target = _ref3.target,
			    touches = _ref3.touches;

			this.EASE = 1;
			document.addEventListener('touchmove', this, { passive: false });
			document.addEventListener('touchend', this);
			var X = touches[0].clientX;
			var Y = touches[0].clientY;
			this.start(target, X, Y);
		},


		/**
   * The document's touchend handler
   *
   * @param  {Object} e The event's object
   */
		touchendHandler: function touchendHandler(e) {
			document.removeEventListener('touchmove', this);
			document.removeEventListener('touchend', this);
			this.end();
		},


		/**
   * The document's touchmove handler
   *
   * @param  {Object} e The event's object
   */
		touchmoveHandler: function touchmoveHandler(e) {
			e.preventDefault();
			var X = e.touches[0].clientX;
			var Y = e.touches[0].clientY;
			this.updatePointerPosition(X, Y);
		}
	},

	watch: {

		/**
   * Initialize the loop when the
   * `IS_LOOPING` is set to `true`
   *
   * @param {Boolean} newValue The new value of the var
   */
		IS_LOOPING: function IS_LOOPING(newValue) {
			if (newValue) this.loop();
		},


		/**
   * Watch the change of the `value` prop
   * and update the component if the change
   * is not coming from direct interaction
   * with the component via mouse or touch
   *
   * @param  {Array} newValue The new value of the var
   */
		value: function value(newValue) {
			if (!this.HAS_INTERACTION) this.updateValue(newValue);
		}
	},

	mounted: function mounted() {
		this.IS_DESTROYED = false;

		this.$slider = this.$el;
		this.$filled = this.$el.querySelector('.range-slider__filled');

		this.$controls = this.$el.querySelectorAll('.range-slider__control');
		this.$controls[0].__TYPE = 'CONTROL_MIN';
		this.$controls[1].__TYPE = 'CONTROL_MAX';

		this.updateSizes();
		this.updateValue(this.value);

		window.addEventListener('resize', this);
	},
	beforeDestroy: function beforeDestroy() {
		this.IS_DESTROYED = true;
		window.removeEventListener('resize', this);
	}
});

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range-slider",
    class: ("range-slider--" + _vm.orientation)
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "range-slider__control range-slider__control--min",
    on: {
      "mousedown": _vm.mousedownHandler,
      "touchstart": _vm.touchstartHandler
    }
  }, [_c('span', {
    staticClass: "range-slider__tooltip range-slider__tooltip--top",
    domProps: {
      "innerHTML": _vm._s(_vm.formatValue(_vm.VALUE_MIN))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "range-slider__control range-slider__control--max",
    on: {
      "mousedown": _vm.mousedownHandler,
      "touchstart": _vm.touchstartHandler
    }
  }, [_c('span', {
    staticClass: "range-slider__tooltip range-slider__tooltip--bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.formatValue(_vm.VALUE_MAX))
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range-slider__track"
  }, [_c('div', {
    staticClass: "range-slider__filled"
  })])
}]}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// range-slider.js